import React from 'react';
import Icon from '../../../components/AppIcon';

// ---------------------------------------------------------------------------
// LoginHeader
//
// Landing-page header for people arriving cold. Written for someone who
// might be 70+ with limited tech comfort:
//   - Big, high-contrast title
//   - One sentence of what the app is
//   - No jargon ("IEP data management system" was replaced with a
//     concrete outcome sentence)
// ---------------------------------------------------------------------------

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      <div className="flex items-center justify-center gap-3 mb-6">
        <div className="w-14 h-14 bg-primary rounded-2xl flex items-center justify-center shadow-lg">
          <Icon name="GraduationCap" size={32} className="text-primary-foreground" />
        </div>
        <div className="text-left">
          <h1 className="text-3xl font-bold text-foreground leading-tight">
            EduTracker Pro
          </h1>
          <p className="text-base text-muted-foreground">
            Special Education, made simple
          </p>
        </div>
      </div>

      <div className="space-y-2">
        <h2 className="text-2xl font-semibold text-foreground">
          Welcome
        </h2>
        <p className="text-base text-muted-foreground max-w-sm mx-auto">
          Track IEP goals, log behavior, and share notes with your team —
          all in one place.
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;
